import Swiper from 'swiper';
import { Grid } from 'swiper/modules';

function sliderMore() {
  new Swiper('.swiper-course-more', {
    modules: [Grid],
    slidesPerView: 1.6,
    grabCursor: true,
    spaceBetween: 48,
    breakpoints: {
      600: {
        slidesPerView: 2.6,
      },
      1110: {
        slidesPerView: 4,
        grid: {
          fill: "row",
          rows: 2,
        },
      }
    }
  });
}
sliderMore();